import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Button } from '@/components/Button';
import { MdOutlineKeyboardArrowDown } from 'react-icons/md';
import { useState } from 'react';
import clsx from 'clsx';

interface Props {
  field: string;
  content?: string | null;
  unit?: string | null;
}

const getCharacterWidth = (str: string): number => {
  return str.split('').reduce((width, char) => {
    // 全角文字（漢字、ひらがな、カタカナ、全角記号など）は1
    // 半角文字（英数字、半角記号など）は0.5
    return (
      width +
      (/[\u3000-\u303f\u3040-\u309f\u30a0-\u30ff\uff00-\uff9f\u4e00-\u9faf]/.test(char) ? 1 : 0.5)
    );
  }, 0);
};

export default function CustomDataField({ field, content, unit }: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const contentWithUnit = content ? `${content}${unit ?? ''}` : null;
  const displayContent = contentWithUnit || '未設定';
  const contentWidth = getCharacterWidth(displayContent);
  const truncatedContent =
    contentWidth > 20
      ? displayContent.split('').reduce((acc, char) => {
          const currentWidth = getCharacterWidth(acc);
          if (currentWidth + getCharacterWidth(char) <= 20) {
            return acc + char;
          }
          return acc;
        }, '') + '...'
      : displayContent;

  return (
    <div className="flex items-center gap-xs text-main">
      <div className="text-heading-3xs font-bold">{field}</div>
      {contentWidth > 20 ? (
        <Popover open={isOpen} onOpenChange={setIsOpen}>
          <span className="text-body-xs">{truncatedContent}</span>
          <PopoverTrigger asChild>
            <Button size="xs" color="secondary" iconOnly>
              <MdOutlineKeyboardArrowDown
                className={`size-icon-3xs transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
              />
            </Button>
          </PopoverTrigger>
          <PopoverContent align="end" className="w-[320px] rounded-sm bg-white px-sm py-xs">
            <div className="max-h-[400px] overflow-y-auto text-body-xs break-words whitespace-pre-wrap">
              {displayContent}
            </div>
          </PopoverContent>
        </Popover>
      ) : (
        <p className={clsx('text-xs', !content && 'text-disabled')}>{displayContent}</p>
      )}
    </div>
  );
}
